var mediaHiding = {};

mediaHiding.init = function() {

  if (!settings.get('mediaHiding'))
    return;

  mediaHiding.hiddenMediaRelation = {};

  var shownFiles = document.getElementsByClassName('uploadCell');

  for (var i = 0; i < shownFiles.length; i++) {
    mediaHiding.processFileForHiding(shownFiles[i]);
  }

  var hiddenMedia = mediaHiding.getHiddenMedia();

  for (i = 0; i < hiddenMedia.length; i++) {
    mediaHiding.updateHiddenFiles(hiddenMedia[i], true);
  }

};

mediaHiding.getHiddenMedia = function() {

  var hiddenMedia = localStorage.hiddenMedia;

  if (hiddenMedia) {
    hiddenMedia = JSON.parse(hiddenMedia);
  } else {
    hiddenMedia = [];
  }

  return hiddenMedia;

};

mediaHiding.updateHiddenFiles = function(file, hiding) {

  var mediaObject = mediaHiding.hiddenMediaRelation[file] || [];

  for (var i = 0; i < mediaObject.length; i++) {

    var element = mediaObject[i];

    element.button.innerHTML = '(' + (hiding ? lang.showFile : lang.hideFile) + ')';

    if (element.element.style.display === 'none' && hiding) {

      var hideLinkList = element.element.parentNode
          .getElementsByClassName('hideLink');

      if (hideLinkList.length) {
        hideLinkList[0].onclick();
      }
    }

    element.element.style.display = hiding ? 'none' : 'inline';
  }

};

mediaHiding.toggleFile = function(fileName) {

  var hiddenMedia = mediaHiding.getHiddenMedia();

  var alreadyHidden = hiddenMedia.indexOf(fileName) > -1;

  if (alreadyHidden) {
    hiddenMedia.splice(hiddenMedia.indexOf(fileName), 1);
  } else {
    hiddenMedia.push(fileName);
  }

  localStorage.hiddenMedia = JSON.stringify(hiddenMedia);

  mediaHiding.updateHiddenFiles(fileName, !alreadyHidden);

};

mediaHiding.processFileForHiding = function(file) {

  var nameLink = file.getElementsByClassName('nameLink')[0];

  var hidingButton = document.createElement('a');
  hidingButton.innerHTML = '(' + lang.hideFile + ')';
  hidingButton.className = 'hideFileButton';

  var fileName = nameLink.href.split('/');
  fileName = fileName[fileName.length - 1];

  hidingButton.onclick = function() {
    mediaHiding.toggleFile(fileName);
  };

  /* Button lives at the TOP of the cell (before everything else).
     Prepend instead of insertBefore(imgLink) because some cells nest
     imgLink inside a wrapper — insertBefore throws if the reference
     node isn't a direct child, which killed init() and broke persistence. */
  file.insertBefore(hidingButton, file.firstChild);

  var mediaObject = mediaHiding.hiddenMediaRelation[fileName] || [];

  mediaObject.push({
    button : hidingButton,
    element : file.getElementsByClassName('imgLink')[0]
  });

  mediaHiding.hiddenMediaRelation[fileName] = mediaObject;

};

mediaHiding.init();
